import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLink } from "@fortawesome/free-solid-svg-icons";
import {
	faGithub,
	faLinkedin,
	faMedium,
	faNpm,
	faStackOverflow,
} from "@fortawesome/free-brands-svg-icons";

import INFO from "../../data/user";

import "./styles/socials.css";

const Socials = () => {
	return (
		<div className="socials">
			<div className="social">
				<a
					href={INFO.socials.github}
					target="_blank"
					rel="noopener noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faGithub}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on GitHub</div>
				</a>
			</div>

			<div className="social">
				<a
					href={INFO.socials.linkedin}
					target="_blank"
					rel="noopener noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faLinkedin}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on LinkedIn</div>
				</a>
			</div>

			{INFO.socials.stackoverflow && (
				<div className="social">
					<a
						href={INFO.socials.stackoverflow}
						target="_blank"
						rel="noopener noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon
								icon={faStackOverflow}
								className="social-icon"
							/>
						</div>
						<div className="social-text">Stack Overflow</div>
					</a>
				</div>
			)}

			{INFO.socials.npm && (
				<div className="social">
					<a
						href={INFO.socials.npm}
						target="_blank"
						rel="noopener noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon icon={faNpm} className="social-icon" />
						</div>
						<div className="social-text">NPM Packages</div>
					</a>
				</div>
			)}

			{INFO.socials.medium && (
				<div className="social">
					<a
						href={INFO.socials.medium}
						target="_blank"
						rel="noopener noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon icon={faMedium} className="social-icon" />
						</div>
						<div className="social-text">Medium Articles</div>
					</a>
				</div>
			)}

			{INFO.socials.linktree && (
				<div className="social">
					<a
						href={INFO.socials.linktree}
						target="_blank"
						rel="noopener noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon icon={faLink} className="social-icon" />
						</div>
						<div className="social-text">Linktree</div>
					</a>
				</div>
			)}

			<div className="email">
				<div className="email-wrapper">
					<a
						href={INFO.main.emailHref}
						aria-label={`Email ${INFO.main.name}`}
					>
						<div className="social-icon">
							<FontAwesomeIcon icon={faEnvelope} />
						</div>

						<div className="social-text">{INFO.main.email}</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Socials;
